<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import VoxHeader from './components/VoxHeader.vue'
import VoxFooter from './components/VoxFooter.vue'
import CookieBanner from './components/CookieBanner.vue'

const route = useRoute()

const isMobile = ref(window.innerWidth <= 992)
const handleResize = () => { isMobile.value = window.innerWidth <= 992 }

onMounted(() => {
  window.addEventListener('resize', handleResize)
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual'
  }
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})

const isSmallFooter = computed(() => {
  if (route.path === '/solutions') return true
  if (isMobile.value && route.path !== '/') return true
  return false
})
</script>

<template>
  <div class="app-wrapper">
    <VoxHeader />
    <main>
      <RouterView />
    </main>
    <VoxFooter :small="isSmallFooter" />

    <CookieBanner />
  </div>
</template>


<style scoped>
.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  background-color: var(--voxbet-grey-01);
}

@media (min-width: 993px) {
  .app-wrapper {
    max-width: 1400px;
    margin: 0 auto;
    box-shadow: 0 0 100px rgba(0,0,0,0.5);
  }
  
  body {
    background-color: #000; /* Darker background outside the box */
  }
}

main {
  flex: 1;
  position: relative;
  z-index: 5;
  padding-top: 70px; /* Base for mobile */
}

@media (min-width: 993px) {
  main {
    padding-top: 110px; /* Extra space for desktop island header */
  }
}


</style>
